/* global axios */
import ApiClient from './ApiClient';

class FollowUpMessagesAPI extends ApiClient {
  constructor() {
    super('funnels', { accountScoped: true });
  }

  // Get all follow-up messages for a stage
  getMessages(funnelId, stageName) {
    return axios.get(
      `${this.url}/${funnelId}/stages/${encodeURIComponent(stageName)}/follow_up_messages`
    );
  }

  // Create a new follow-up message
  createMessage(funnelId, stageName, messageData) {
    return axios.post(
      `${this.url}/${funnelId}/stages/${encodeURIComponent(stageName)}/follow_up_messages`,
      messageData
    );
  }

  // Update a follow-up message
  updateMessage(funnelId, stageName, messageId, messageData) {
    return axios.patch(
      `${this.url}/${funnelId}/stages/${encodeURIComponent(stageName)}/follow_up_messages/${messageId}`,
      messageData
    );
  }

  // Delete a follow-up message
  deleteMessage(funnelId, stageName, messageId) {
    return axios.delete(
      `${this.url}/${funnelId}/stages/${encodeURIComponent(stageName)}/follow_up_messages/${messageId}`
    );
  }

  // Bulk update messages (reorder, enable/disable multiple)
  bulkUpdateMessages(funnelId, stageName, messages) {
    return axios.put(
      `${this.url}/${funnelId}/stages/${encodeURIComponent(stageName)}/follow_up_messages/bulk`,
      { follow_up_messages: messages }
    );
  }
}

export default new FollowUpMessagesAPI();
